/**
 * Vision / multimodal model detection.
 *
 * Used to gate image-related PowerPoint tools (e.g. take_slide_screenshot)
 * so they are only offered to models that can actually process images.
 */

/** Provider template slugs whose models all support vision. */
const VISION_PROVIDER_SLUGS = new Set([
  'aws-bedrock',   // Anthropic Claude
  'openai',        // OpenAI
  'azure-openai',  // OpenAI via Azure
  'google',        // Google Gemini
]);

/**
 * Model slug patterns that indicate vision support.
 * Used as a fallback for generic providers (openai-compatible, litellm)
 * where the provider slug alone doesn't tell us the model family.
 */
const VISION_MODEL_PATTERNS = [
  /claude/i,
  /gpt/i,
  /^o[1-9]/i,   // OpenAI reasoning models (o1, o3, o4, …)
  /gemini/i,
  /qwen/i,
];

/**
 * Returns `true` when the provider + model combination is known to support
 * vision (multimodal image input).
 */
export function isVisionModel(
  providerSlug?: string,
  modelSlug?: string,
): boolean {
  if (providerSlug && VISION_PROVIDER_SLUGS.has(providerSlug)) {
    return true;
  }

  if (modelSlug) {
    return VISION_MODEL_PATTERNS.some((p) => p.test(modelSlug));
  }

  return false;
}

/** Frontend PowerPoint tool names that require a vision-capable model. */
export const VISION_REQUIRED_TOOLS = new Set([
  'take_slide_screenshot',
]);
